const DOMAIN_ICONS: Record<string, string> = {
  "gmail.com": "/icons/gmail.svg",
  "googlemail.com": "/icons/gmail.svg",
  "outlook.com": "/icons/microsoft.svg",
  "hotmail.com": "/icons/microsoft.svg",
  "live.com": "/icons/microsoft.svg",
  "msn.com": "/icons/microsoft.svg",
  "yahoo.com": "/icons/yahoo.svg",
  "ymail.com": "/icons/yahoo.svg",
  "rocketmail.com": "/icons/yahoo.svg",
  "icloud.com": "/icons/icloud.svg",
  "me.com": "/icons/icloud.svg",
  "mac.com": "/icons/icloud.svg"
};

const PROVIDER_ICONS: Record<string, string> = {
  google: "/icons/gmail.svg",
  microsoft: "/icons/microsoft.svg"
};

export const getEmailIcon = (
  email: string,
  provider?: string
): string | null => {
  const byProvider = provider ? PROVIDER_ICONS[provider] : undefined;
  if (byProvider) return byProvider;

  const domain = email.split("@")[1]?.toLowerCase() ?? "";
  return DOMAIN_ICONS[domain] ?? null;
};
